import React from "react";
import "./module-tabs.css";

const ModuleTabs = ({
	tabs = [],
	activeKey = "",
	onChange,
	className = ""
}) => {
	if (!Array.isArray(tabs) || tabs.length === 0) {
		return null;
	}

	return (
		<nav
			className={`module-tabs ${className}`.trim()}
			aria-label="Navegação dos módulos"
		>
			<div className="module-tabs__list" role="tablist">
				{tabs.map(tab => {
					const isActive = activeKey === tab.key;

					return (
						<button
							key={tab.key}
							type="button"
							role="tab"
							aria-selected={isActive}
							className={[
								"module-tabs__item",
								isActive ? "module-tabs__item--active" : ""
							].filter(Boolean).join(" ")}
							onClick={() => onChange(tab.key)}
						>
							{tab.label}
						</button>
					);
				})}
			</div>
		</nav>
	);
};

export default ModuleTabs;